<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Planta de Abate</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md4 lg4>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nrRegistroSif" label="Registro no SIF" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md7 lg7>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmPlantaAbate" label="Nome Fantasia" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Localização</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center="">
                <v-flex class="item" xs11 md4 lg4>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdUf" :items="ufs"
                        color="primary" item-text="sgUf" item-value="idUf" label="Selecione a UF"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md7 lg7>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdMunicipio" :items="filteredCities"
                        color="primary" item-text="nmMunicipio" item-value="idMunicipio" label="Selecione o Município"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>                
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio } from '@/filters/rules'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

export default {
    name: 'PlantaAbate',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            filteredCities: [],
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Planta de Abate: ' + this.registro.idPlantaAbate

                return 'Inserindo nova Planta de Abate'
            }
        },
        ufs () {
            return this.$store.state.ufs
        },
        municipios () {
            return this.$store.state.municipios
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadUFs')
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('planta-abate/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.registro = Object.assign({}, rec)
                this.registroBanco = Object.assign({}, rec)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
                this.$router.push({ path: '/plantaAbate'})
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.$axios.post('planta-abate/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'plantaAbate', params: { id: response.data[0].data.idPlantaAbate }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadPlantasAbate')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.$axios.put('planta-abate/' + this.registro.idPlantaAbate, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadPlantasAbate')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('planta-abate/' + this.registro.idPlantaAbate)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadPlantasAbate')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/plantaAbate' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idPlantaAbate: 0,
                nrRegistroSif: '',
                nmPlantaAbate: '',
                cdPais: 1,
                cdUf: 0,
                cdMunicipio: 0
            }
            this.registroBanco = {
                idPlantaAbate: 0,
                nrRegistroSif: '',
                nmPlantaAbate: '',
                cdPais: 1,
                cdUf: 0,
                cdMunicipio: 0
            }
        },
        goSearch() {
            this.$router.push({ path: '/plantaAbateSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
        'registro.cdUf' (value){
            this.filteredCities = []
            if (value != undefined)
            {
                if (!this.municipios.some(function(elem) { return elem.cdUf == value}) && value != 0)
                {
                    this.$store.dispatch('actLoadMunicipiosByUf', value)
                }
                else
                {
                    this.filteredCities = this.municipios.filter(x => x.cdUf == value)
                }
            }
            this.cdMunicipio = 0
        },
        'municipios' (value) {
            this.filteredCities = value.filter(x => x.cdUf == this.registro.cdUf)
        }
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
